function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.6443 7.76708C16.6443 7.64922 16.5478 7.5528 16.43 7.5528L14.6621 7.56083L11.9996 10.7349L9.3398 7.56351L7.56927 7.55547C7.45141 7.55547 7.35498 7.64922 7.35498 7.76976C7.35498 7.82065 7.37373 7.86887 7.40587 7.90905L10.8907 12.0608L7.40587 16.2099C7.37351 16.2492 7.35555 16.2983 7.35498 16.3492C7.35498 16.4671 7.45141 16.5635 7.56927 16.5635L9.3398 16.5555L11.9996 13.3814L14.6594 16.5528L16.4273 16.5608C16.5452 16.5608 16.6416 16.4671 16.6416 16.3465C16.6416 16.2957 16.6228 16.2474 16.5907 16.2073L13.1112 12.0582L16.5961 7.90637C16.6282 7.86887 16.6443 7.81797 16.6443 7.76708Z",
  fill: "#AC0B16"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.00299072C5.37321 0.00299072 0 5.3762 0 12.003C0 18.6298 5.37321 24.003 12 24.003C18.6268 24.003 24 18.6298 24 12.003C24 5.3762 18.6268 0.00299072 12 0.00299072ZM12 21.9673C6.49821 21.9673 2.03571 17.5048 2.03571 12.003C2.03571 6.50121 6.49821 2.03871 12 2.03871C17.5018 2.03871 21.9643 6.50121 21.9643 12.003C21.9643 17.5048 17.5018 21.9673 12 21.9673Z",
  fill: "#AC0B16"
});

const SvgErrorIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-icon.a5fdf596.svg";
export { ForwardRef as ReactComponent };